import React from 'react';
import { Modal as ReactModal } from 'react-bootstrap';

export default function Modal(props, context) {
  const i18n = context.i18n || { t: (str) => str };
  const cancelButtonType = props.cancelButtonType || 'default';
  const acceptButtonType = props.acceptButtonType || 'success';
  const show = props.hasOwnProperty('show') ? props.show : true;
  return (
    <ReactModal show={ show } className={ props.className } onHide={ props.onClose } backdrop="static" keyboard={ false } dialogClassName={props.dialogClassName || ''}>
      <ReactModal.Header closeButton>
        <ReactModal.Title>{ props.title }</ReactModal.Title>
      </ReactModal.Header>
      <ReactModal.Body className="box">
        { props.children }
      </ReactModal.Body>
      { props.noFooter ? null :
        <ReactModal.Footer>
          <button onClick={ props.onCancel ? props.onCancel : props.onClose } disabled={ props.loading } type="button" className={ `btn btn-sm btn-${cancelButtonType}` }>
            { props.labelCancel ? props.labelCancel : i18n.t('Cancel') }
          </button>
          {
            props.onAccept
              ? <button onClick={ props.onAccept } disabled={ props.loading } type="button" className={ `btn btn-sm btn-${acceptButtonType}` }>
                  { props.labelAccept ? props.labelAccept : i18n.t('Ok') }
                </button>
              : null
          }
        </ReactModal.Footer>
      }

    </ReactModal>
  );
}

Modal.contextTypes = {
  i18n: React.PropTypes.object
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Modal.jsx